export default __webpack_public_path__ + "static/media/Master.14dca9c8.svg";